import axios from 'axios';

const axiosInstance = axios.create({
  withCredentials: true,
  validateStatus: () => true,
  baseURL: 'https://api.tribetix.com',
});

export default axiosInstance;
